module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfBxc4AMP6lbBP.b770bd5b.woff2";